import React from 'react'
import { Button, CardGroup, Card} from 'react-bootstrap'

const Chest = () => {
  return (

    <>
    <br/>
    <div className="d-grid gap-3">
          <Button style={{height:'70px'}} variant="secondary" size="lg"> Videos for train Chest</Button>
        </div>
    
        <CardGroup>
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%" 
                        // autoPlay="false" 
                        controls>
                        <source src="chest1.mp4" type="video/mp4" />
                    </video>
                </div>
                    <Card.Title style={{textAlign:'center'}}>Chest workout at home</Card.Title>
                    {/* <Card.Text>
                    In this video I take you 7 different bicep exercises you can do to get bigger arms! 
                    These are CRUCIAL exercises to add to your arm day arsenal to grow your biceps.
                    </Card.Text>  */}
                </Card>
    
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%"
                        // autoPlay="false" 
                        controls>
                        <source src="chest2.mp4" type="video/mp4" />
                    </video>
                </div>
                <Card.Title style={{textAlign:'center'}}>Chest workout at gym</Card.Title>
                </Card>
        </CardGroup>
    
    
        <CardGroup>
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%" 
                        // autoPlay="false" 
                        controls>
                        <source src="chest3.mp4" type="video/mp4" />
                    </video>
                </div>
                <Card.Title style={{textAlign:'center'}}>Chest workout with only dumbells</Card.Title>
                </Card>
    
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%" 
                        // autoPlay="false" 
                        controls>
                        <source src="chest4.mp4" type="video/mp4" />
                    </video>
                </div>
                <Card.Title style={{textAlign:'center'}}>Chest workout for begginers</Card.Title>
                </Card>
        </CardGroup>
    
    </>
  )
}

export default Chest